
import axios from "axios";
import { Component } from 'react';
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { validateAddVendorForm } from '../../utils/validation';
import CommonLoader from '../loaderComponent/CommonLoader';
import CommonToast from './../Toaster/CommonToast';

export default class VendorList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      gst: "",
      phone: "",
      email: "",
      address: "",
      status: "",
      hasError: false,
      errMsg: "",
      completed: false,
      errors: {},
      showToast: false,
      toastMessage: '',
      toastVariant: '',
      color: '',
      loading: true,
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ loading: false })
    }, 900);
  }

  handleChange = (event) => {
    // debugger
    const { value, name } = event.target;
    let errors = { ...this.state.errors };
    if (name === "phone" && value && !/^\d*$/.test(value)) {
      return;
    }
    if (value.trim()) {
      delete errors[name];
    }
    this.setState({
      [name]: value,
      errors
    });
  };

  onSubmit = async (e) => {
    this.setState({ loading: true })
    e.preventDefault();
    let token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };

    this.setState({ hasError: false, errMsg: "", completed: false, loading: true });
    const errors = validateAddVendorForm(
      this.state.name, this.state.email, this.state.phone, this.state.address, this.state.gst, this.state.status
    );
    let vendorData = {
      name: this.state.name,
      gst: this.state.gst,
      phone: this.state.phone,
      email: this.state.email,
      address: this.state.address,
      status: this.state.status
    };
    if (Object.keys(errors).length > 0) {
      this.setState({ errors, loading: false });
      return;
    }
    try {
      await axios.post('/vendor', vendorData, { headers });
      this.setState({
        completed: true,
        toastMessage: "Vendor created successfully!",
        toastVariant: 'success',
        color: 'green',
        showToast: true,
      });
      setTimeout(() => {
        this.setState({ loading: false, showToast: false });
        this.props.history.push("/vendor-list");
      }, 900);

    } catch (error) {
      if (error.response) {
        // Server responded with a status other than 2xx
        console.error('Error response from server:', error.response.data);
        const errorMessage = error.response.data.error; // Extracting the error message
        if (errorMessage === "Name already exists") {
          this.setState({ hasError: true, errMsg: "A vendor with the same Name and GST Number already exists." });
        } else {
          this.setState({ hasError: true, errMsg: "Failed to add vendor." });
        }
      } else {
        // Other errors
        console.error('Error adding vendor:', error.message);
        this.setState({
          hasError: true, errMsg: "An unexpected error occurred.",
          toastMessage: "Vendor not created!",
          toastVariant: 'danger',
          color: 'red',
          showToast: true,

        });
        setTimeout(() => {
          this.setState({ loading: false, showToast: false });
        }, 900);
      }
    }
  };

  handleBack = () => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.props.history.push("/vendor-list");
      this.setState({ loading: false });
    }, 500);
  }

  render() {
    return (
      <div className="pt-4">
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />
        <CommonLoader isLoading={this.state.loading}>
          <>
            {/* {this.state.hasError ? (
            <Alert variant="outline-danger" className="m-3">
              {this.state.errMsg}
            </Alert>
          ) : this.state.completed ? (
            <>
              <Loader />
              <Redirect to="/vendor-list" />
            </>
          ) : null} */}

            <Card className="shadow-sm rounded border-0">
              <Card.Header className="text-white">
                <strong>Add Vendor</strong>
              </Card.Header>
              <Card.Body>
                <Form onSubmit={this.onSubmit}>

                  <Row className="mb-3">
                    <Col xs={12} md={4} lg={4}>
                      <Form.Group>
                        <Form.Label className="text-muted required">Vendor Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          value={this.state.name}
                          placeholder='Enter vendor name'
                          onChange={this.handleChange}
                        />
                      </Form.Group>
                      <span className="login-error">
                        {this.state.errors.name && <small className="text-danger">{this.state.errors.name}</small>}
                      </span>
                    </Col>
                    <Col xs={12} md={4} lg={4}>
                      <Form.Group>
                        <Form.Label className="text-muted required">Email</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          value={this.state.email}
                          placeholder='Enter vendor email'
                          onChange={this.handleChange}
                        />
                      </Form.Group>
                      <span className="login-error">
                        {this.state.errors.email && <small className="text-danger">{this.state.errors.email}</small>}
                      </span>
                    </Col>
                    <Col xs={12} md={4} lg={4}>
                      <Form.Group>
                        <Form.Label className="text-muted required">Mobile</Form.Label>
                        <Form.Control
                          type="text"
                          name="phone"
                          value={this.state.phone}
                          placeholder='Enter vendor mobile'
                          onChange={this.handleChange}
                          maxLength={10}
                          inputMode="numeric"
                          pattern="\d*"
                        />
                      </Form.Group>
                      <span className="login-error">
                        {this.state.errors.phone && <small className="text-danger">{this.state.errors.phone}</small>}
                      </span>

                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col xs={12} md={4} lg={4}>
                      <Form.Group>
                        <Form.Label className="text-muted required">GST Number</Form.Label>
                        <Form.Control
                          type="text"
                          name="gst"
                          value={this.state.gst}
                          placeholder='Enter GST number'
                          onChange={this.handleChange}

                        />
                      </Form.Group>
                      <span className="login-error">
                        {this.state.errors.gst && <small className="text-danger">{this.state.errors.gst}</small>}
                      </span>
                    </Col>
                    <Col xs={12} md={4} lg={4}>
                      <Form.Group>
                        <Form.Label className="text-muted required">Address</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={1}
                          name="address"
                          value={this.state.address}
                          placeholder='Enter vendor address'
                          onChange={this.handleChange}

                        />
                      </Form.Group>
                      <span className="login-error">
                        {this.state.errors.address && <small className="text-danger">{this.state.errors.address}</small>}
                      </span>
                    </Col>
                    <Col xs={12} md={4} lg={4}>
                      <Form.Group>
                        <Form.Label className="text-muted required">Status</Form.Label>
                        <Form.Control
                          as="select"
                          className="form-select"
                          name="status"
                          value={this.state.status || ''}
                          onChange={this.handleChange}
                        >
                          <option value="" disabled>
                            Select Status
                          </option>
                          <option value="Active">Active</option>
                          <option value="Inactive">Inactive</option>
                        </Form.Control>
                      </Form.Group>
                      <span className="login-error">
                        {this.state.errors.status && <small className="text-danger">{this.state.errors.status}</small>}
                      </span>
                    </Col>
                  </Row>
                  <div className='add-cancel-btn '>
                    <Button variant='primary' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary" type="submit" >
                      Add
                    </Button>
                    <Button variant='danger' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button-cancel" onClick={this.handleBack}>Cancel</Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </>
        </CommonLoader>
      </div>
    );
  }
}
